import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../store/hooks";
import { User } from "../../../types/User";
import { getBrandLogoAlt, getBrandLogoSrc, isVelvetUiActive } from "../../../utils/brandLogo";

const linkData = [
  {
    name: "Home",
    href: "/",
  },
  {
    name: "Services",
    href: "/services",
  },
  {
    name: "FAQ",
    href: "/faq",
  },
  {
    name: "Contact Us",
    href: "/contact",
  },
  {
    name: "Contact Us",
    href: "/contact",
  },
  {
    name: "Careers",
    href: "/careers",
  },
  {
    name: "Login",
    href: "/dashboard",
  },
];

const Footer = () => {
  const user = useAppSelector((state) => state.auth.user as User | null);
  const { pathname } = useLocation();
  const isVelvet = isVelvetUiActive(user, pathname);

  return (
    <footer
      className={`${
        isVelvet ? "bg-[#E8D9C4] text-[#2C2C2C]" : "bg-[#18191d] text-white"
      } flex items-center justify-center p-3 md:p-0 `}
    >
      <div className="w-full max-w-6xl py-12 relative">
        <hr
          className={`absolute top-0 left-1/2 transform -translate-x-1/2 w-[95%] ${
            isVelvet ? "border-[#D4C4A8]" : "border-gray-700"
          }`}
        />
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-start gap-8">
          {/* Left Section */}
          <div className=" text-lg md:text-md">
            {user?.partner ? null : (
              <nav className="flex flex-col ">
                {linkData.map((item, index) => (
                  <a
                    key={index}
                    href={item.href}
                    className="opacity-50 hover:opacity-100 transition underline"
                  >
                    {item.name}
                  </a>
                ))}
              </nav>
            )}
          </div>

          {/* Right Section */}
          <div className="space-y-4 md:text-right w-full md:w-auto flex flex-col gap-2 md:text-md justify-end text-right">
            <div className="flex justify-end cursor-pointer hover:scale-105 transition-all duration-300">
              <Link to="/">
                <img
                  src={getBrandLogoSrc(user, pathname)}
                  alt={getBrandLogoAlt(user, pathname)}
                  className="w-72 h-auto mx-auto md:mx-0"
                />
              </Link>
            </div>

            <div className="flex flex-col gap-4 ">
              {/* Social Icons */}
              <div className="flex justify-end md:text-md gap-2">
                <a
                  href="mailto:enquiry@toothsketch.com"
                  aria-label="Email"
                  className={`overflow-hidden rounded-full border-2 p-1 hover:scale-100 transition-all duration-300 ${
                    isVelvet ? "border-[#8B7355]" : "border-white"
                  }`}
                >
                  <HiOutlineMail />
                </a>
                <a
                  href="https://www.facebook.com/ToothSketch"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className={`overflow-hidden rounded-full border-2 p-1 hover:scale-100 transition-all duration-300 ${
                    isVelvet ? "border-[#8B7355]" : "border-white"
                  }`}
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/toothsketch/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className={`overflow-hidden rounded-full border-2 p-1 hover:scale-100 transition-all duration-300 ${
                    isVelvet ? "border-[#8B7355]" : "border-white"
                  }`}
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.linkedin.com/company/toothsketch"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className={`overflow-hidden rounded-full border-2 p-1 hover:scale-100 transition-all duration-300 ${
                    isVelvet ? "border-[#8B7355]" : "border-white"
                  }`}
                >
                  <FaLinkedinIn />
                </a>
              </div>

              {/* Contact Info */}
              <div className="space-y-1 text-[13px]">
                <p className="opacity-50">
                  ©2020 ToothSketch LLP. All rights reserved.
                </p>
                <a href="tel:+447882347988">
                  <p className="opacity-50 hover:opacity-100 cursor-pointer">
                    +44 788 234 7988
                  </p>
                </a>
                <a href="tel:+17017381847">
                  <p className="opacity-50 hover:opacity-100 cursor-pointer">
                    +1 701 738 1847
                  </p>
                  {/* <p className="opacity-50 hover:opacity-100 cursor-pointer">
                    +1 646 762 6241
                  </p> */}
                </a>
                <a
                  href="mailto:enquiry@toothsketch.com"
                  className="opacity-50 hover:opacity-100 block"
                >
                  enquiry@toothsketch.com
                </a>
                <p className="flex justify-end opacity-50 gap-1">
                  <a
                    href="/terms-conditions"
                    className="hover:opacity-100 block underline"
                  >
                    Terms
                  </a>
                  -
                  <a
                    href="/privacy-policy"
                    className="hover:opacity-100 block underline"
                  >
                    Privacy
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
